"use strict";

module.exports = function (_ref) {
  var _ref$version = _ref.version,
      version = _ref$version === void 0 ? {} : _ref$version,
      _ref$env = _ref.env,
      env = _ref$env === void 0 ? '' : _ref$env;
  var timestamp = version.timestamp,
      git = version.git,
      _version$ci = version.ci,
      ci = _version$ci === void 0 ? '' : _version$ci,
      _version$pkg = version.pkg,
      pkg = _version$pkg === void 0 ? '' : _version$pkg;
  var versionString = git || pkg;
  var date = timestamp ? new Date(timestamp).toLocaleString() : '-';

  try {
    console.log("%c %s %c Bits of Love %c\u2665 %c%s %c %s %c%s", 'background-color:#ff004c;color:#fff;', env, 'background-color:#000;color:#fff;', 'background-color:#000;color:#ff5400;', 'background-color:#000;color:#fff', date, 'background-color:#299531;color:#fff', versionString, 'background-color:#2c9bb9;color:#fff;', " ".concat(ci, " "));
  } catch (e) {//
  }
};